import type { AppIconProps } from "../IconTypes";

export const InfoIcon: React.FC<AppIconProps> = ({
  width,
  height,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#1d9f81"
        d="M7.2 3.8c0 .4.3.7.7.7c.4 0 .7-.3.7-.7c0-.4-.3-.7-.7-.7c-.4 0-.7.3-.7.7M5.5 12.5c0 .2.1.3.3.3h4.4c.2 0 .3-.1.3-.3c0-.2-.1-.3-.3-.3h-1.4V6.3c0-.2-.1-.3-.3-.3h-2.2c-.2 0-.3.1-.3.3c0 .2.1.3.3.3h1.5v5.2h-1.7c-.2 0-.3.1-.3.3"
      />
    </svg>
  );
};
